import React from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import * as Messages from '../../components/ui/messages/messages'
import { AppContext } from '../../App'
import { Link, PlusSquare } from 'react-feather'
import { useNavigate } from 'react-router-dom'
import HandleEvent, { HandleEventPopUpProps } from './accountCreationHandleEvent'

const AccountCreationConfirmation = () => {
	const { appState, updateAppState } = React.useContext(AppContext)
	const [messages, setMessages] = Messages.useMessageReducer([])
	const [showDialog, updateShowDialog] = React.useState<boolean>(false)
	const [choice, updateChoice] = React.useState<HandleEventPopUpProps['popUpEventType']>('')
	const navigate = useNavigate()

	return (
		<Container className="text-center mt-6">
			{/* <Card title="Create Account" className="extra-padded"> */}
			<Row>
				<Col>
					<Row>
						<Col className="p-10">
							<h3>Welcome {appState.authState.attributes?.given_name} - what are you trying to do today?</h3>
						</Col>
					</Row>
					<Row className="justify-content-center">
						<Col sm="auto">
							<Button
								className="big-button"
								variant="outline-secondary"
								onClick={() => {
									try {
										updateChoice('Create')
										updateShowDialog(true)
									} catch (err) {
										setMessages({
											type: 'add',
											data: {
												severity: 'danger',
												timeout: 0,
												message: 'Failed to create account',
												dismissible: true,
											},
										})
									}
								}}
							>
								<PlusSquare size={100} />
								<div>I want to create a new trial of Billy.</div>
							</Button>
						</Col>
						<Col sm="auto">
							<Button
								className="big-button"
								variant="outline-secondary"
								onClick={() => {
									try {
										updateChoice('Join')
										updateShowDialog(true)
									} catch (err) {
										setMessages({
											type: 'add',
											data: {
												severity: 'danger',
												timeout: 0,
												message: 'Failed to display information about existing organisation',
												dismissible: true,
											},
										})
									}
								}}
							>
								<Link size={100} />
								<div>I want to join a Billy account already setup for my company.</div>
							</Button>
						</Col>
					</Row>
				</Col>
			</Row>
			{showDialog && (
				<HandleEvent
					popUpEventType={choice}
					handleClose={() => {
						updateShowDialog(false)
					}}
					show={showDialog}
					updateMessages={setMessages}
					appState={appState}
					updateAppState={updateAppState}
					navigate={navigate}
				/>
			)}
			{/* </Card> */}
			<Messages.Messages messages={messages} updateMessage={setMessages} />
		</Container>
	)
}
export default AccountCreationConfirmation
